import {AUDIO_INPUT, VIDEO_INPUT} from '../../../redux/modules/video-settings';

export const EMPTY = {
  [VIDEO_INPUT]: 'Please connect a camera',
  [AUDIO_INPUT]: 'Please connect an audio input device',
};
